import { render, staticRenderFns } from "./MyTags.vue?vue&type=template&id=07b11656&scoped=true&"
import script from "./MyTags.vue?vue&type=script&lang=js&"
export * from "./MyTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b11656",
  null
  
)

export default component.exports